import { Helmet } from "react-helmet"
import Layout from "../components/layout/Layout"
import Brand1 from "../components/sections/Brand1"
import ServiceDetails2 from "../components/sections/ServiceDetails2"
import Imgsec4 from "../components/sections/imgsec4"
export default function ServicesDetails() {
	return (
		<>
			<Helmet>
				<title>WPC Doors | V-Make</title>
				<meta name="description" content="Discover premium WPC Doors from V-Make—durable, water-resistant, termite-proof, and designed for both interior and exterior use. Perfect for modern homes and commercial spaces." />
				<meta name="keywords" content="WPC doors, wood plastic composite doors, V-Make doors, termite-proof doors, water-resistant doors, eco-friendly doors, modern door designs, interior WPC doors, exterior WPC doors" />
				<link rel="canonical" href="https://vmakewpc.com/Wpc-Doors" />
				<meta property="og:title" content="V-Make | WPC Doors" />
				<meta property="og:description" content="Explore V-Make's range of WPC Doors—sustainable, stylish, and built to last. Ideal for modern interiors and exteriors." />
				<meta property="og:url" content="https://vmakewpc.com/Wpc-Doors"/>
				<meta property="og:image" content="https://vmakewpc.com/assets/img/service/Door-1.jpg" />
			</Helmet>
			<Layout
				headerStyle={1}
				footerStyle={1}
			// breadcrumbTitle="Services details"
			>
				<ServiceDetails2 />
				{/* <Brand1 /> */}
				<Imgsec4 />
			</Layout>
		</>
	)
}
